import React from 'react';
import { whatsappConfig } from '../whatsappConfig';

export default function Contact() {
    const handleSubmit = (e) => {
        e.preventDefault();

        const name = document.getElementById("name").value;
        const email = document.getElementById("email").value;
        const phone = document.getElementById("phone").value;
        const message = document.getElementById("message").value;

        const whatsappNumber = whatsappConfig.phoneNumber.replace(/[+\s]/g, "");

        const text = `New contact message:
                        Full Name: ${name}
                        Email: ${email}
                        Phone: ${phone}
                        Message: ${message}`;

        const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(text)}`;

        window.open(url, "_blank");
    };

    return (
        <section className="py-5">
            <div className="container px-5">
                <div className="bg-light rounded-3 py-5 px-4 px-md-5 mb-5">
                    <div className="text-center mb-5">
                        <div className="feature bg-primary bg-gradient text-white rounded-3 mb-3">
                            <i className="bi bi-envelope"></i>
                        </div>
                        <h1 className="fw-bolder">Get in touch</h1>
                        <p className="lead fw-normal text-muted mb-0">We'd love to hear from you</p>
                    </div>

                    <div className="row gx-5 justify-content-center">
                        <div className="col-lg-8 col-xl-6">

                            <form id="contactForm" onSubmit={handleSubmit}>
                                {/* Name */}
                                <div className="form-floating mb-3">
                                    <input className="form-control" id="name" type="text" placeholder="Enter your name..." required />
                                    <label htmlFor="name">Full name</label>
                                </div>

                                {/* Email */}
                                <div className="form-floating mb-3">
                                    <input className="form-control" id="email" type="email" placeholder="name@example.com" required />
                                    <label htmlFor="email">Email address</label>
                                </div>

                                {/* Phone */}
                                <div className="form-floating mb-3">
                                    <input className="form-control" id="phone" type="tel" placeholder="(123) 456-7890" required />
                                    <label htmlFor="phone">Phone number</label>
                                </div>

                                {/* Message */}
                                <div className="form-floating mb-3">
                                    <textarea
                                        className="form-control"
                                        id="message"
                                        placeholder="Enter your message here..."
                                        style={{ height: "180px" }}
                                        required
                                    ></textarea>
                                    <label htmlFor="message">Message</label>
                                </div>

                                {/* Submit Button */}
                                <div className="d-grid">
                                    <button className="btn btn-primary btn-lg" id="submitButton" type="submit">
                                        Submit via WhatsApp
                                    </button>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>

                {/* Map */}
                <div className="rounded-3 overflow-hidden shadow">
                    <iframe
                        title="Location Map"
                        src="https://www.google.com/maps/embed?!1m18!1m12!1m3!1d3915.79069!2d76.9553!3d11.0016!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba857fd0b000001%3A0xabcdef123456789!5e0!3m2!1sen!2sin!4v1234567890"
                        width="100%"
                        height="350"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                </div>

            </div>
        </section>
    );
}
